/**
 * Dashboard - Places listing
 */

'use strict';

// Constructor
var FrontDashboardPlacesIndex = function () {
    if (!($('body').hasClass('dashboard-places') || $('body').hasClass('dashboard-places-publish') || $('body').hasClass('dashboard-places-draft') || $('body').hasClass('dashboard-places-pending'))) {
        return;
    }

    $(document).ready((function () {
        this.updateStateSelect();
        this.stateSelectLoadPage();
        this.openModalDelete();
        this.delete();
        this.uiMatchHeight();
        this.updateStatus();
    }).bind(this));
};

FrontDashboardPlacesIndex.prototype = {
    lockAjaxForm: false,

    updateStatus: function() {
        var self = this;

        $('.update-status').change(function() {
            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            if ($(this).is(":checked")) {
                // Enable the post
                var statusValue = 1;
            } else {
                // Disable the post
                var statusValue = 0;
            }

            var item = $(this).parents('.item');

            $('.preloader-wrapper', item).fadeIn();

            var idValue = $(this).parents('.inner').find('.edition .btn-delete').data('id');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.places.update_status',
                    security: comedien.security,
                    idPlace: idValue,
                    status: statusValue
                }
            }).done(function (response) {
                if (response.success) {
                    $('.preloader-wrapper', item).fadeOut();

                    if (statusValue == 0) {
                        $('.item .btn-delete[data-id=' + idValue + ']').parents('.item').fadeOut();
                    }
                }

                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
                M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });
    },

    updateStateSelect: function () {
        var state = $('.listing').data('state');

        var select = $('.section-actions select.state-select')

        if (state.length > 0) {
            select.find('option[value="' + state + '"]').prop('selected', true);
            select.formSelect();
        }
    },

    stateSelectLoadPage: function () {
        $('.section-actions select.state-select').on('change', function () {
            var state = $(this).val();
            if (state.length > 0) {
                var url = $(this).find('[value=' + state + ']').data('url');
            } else {
                var url = $(this).find('[value=""]').data('url');
            }
            window.location = url;
        });
    },

    openModalDelete: function() {
        $('body').on('click', '.item .btn-delete', function() {
            var idValue = $(this).data('id');
            var modalElement = $('#modal-dashboard-place-delete');

            modalElement.find('.btn-confirm').attr('data-id', idValue);

            modalElement.find('.content-before').removeClass('hidden');
            modalElement.find('.content-after').addClass('hidden');

            modalElement.find('.btn-confirm').removeClass('disabled');
            modalElement.find('.content-before .modal-action').removeClass('disabled');

            modalElement.modal('open');
        });
    },

    delete: function () {
        var self = this;
        var modalElement = $('#modal-dashboard-place-delete');

        $('#modal-dashboard-place-delete .btn-confirm').on('click', function () {
            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            var idValue = $(this).attr('data-id');

            $('.preloader-wrapper', modalElement).fadeIn();
            $('.content-before .btn-confirm', modalElement).addClass('disabled');
            $('.content-before .modal-action', modalElement).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.places.delete',
                    security: comedien.security,
                    idPlace: idValue,
                }
            }).done(function (response) {
                if (response.success) {
                    $('.preloader-wrapper', modalElement).fadeOut();
                    modalElement.find('.content-before').addClass('hidden');
                    modalElement.find('.content-after').removeClass('hidden');
                    $('.item .btn-delete[data-id=' + idValue + ']').parents('.item').remove();

                    self.uiMatchHeight();
                }

                $('.preloader-wrapper', modalElement).hide();

                self.lockAjaxForm = false;
                modalElement.find('.btn-confirm').attr('data-id', '');
                modalElement.modal('close');
            }).fail(function (jqXHR, textStatus) {
                $('.preloader-wrapper', modalElement).hide();
                self.lockAjaxForm = false;
                console.log("Request failed: " + textStatus);
                modalElement.modal('close');
            });
        });
    },

    uiMatchHeight: function() {
        $('#dashboard-places .item').matchHeight();
        $('main#content > .col').matchHeight();
    },
};

module.exports = new FrontDashboardPlacesIndex();
